import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

const Campaigns: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="text-3xl font-bold text-slate-500 text-center mt-60">
      <p>Coming Soon...</p>
      <Button
        onClick={() => navigate(-1)}
        variant="ghost"
        className="mt-4 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
      >
        Go Back
      </Button>
    </div>
  );
};

export default Campaigns;
